import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type {
  InitialStateType,
  BlacklistSummaryType,
  SetQueryPayloadActionType,
  SetModalPayloadActionType,
} from 'features/Location/@types/BlacklistArea'

export const SLICE_NAME = 'blacklistArea'

export const initialState: InitialStateType = {
  isLoading: [],
  blacklistSummary: [],
  query: { limit: 20, location_name: '', page: 0 },
  modal: { mode: '', file: null },
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setQuery: (state, { payload }: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...payload }
    },
    setModal: (state, { payload }: PayloadAction<SetModalPayloadActionType>) => {
      state.modal = { ...state.modal, ...payload }
    },
    setBlackListSummary: (state, { payload }: PayloadAction<BlacklistSummaryType[]>) => {
      state.blacklistSummary = payload
    },
  },
})

export const { reset, setIsLoading, setBlackListSummary, setQuery, setModal } = slice.actions
export default slice.reducer
